import apiClient from "./axios"
import { downloadAndOpenFile } from "./pdfApi"

// ✅ Get accessories stock list (with filters / pagination)
export const getAccessoriesStockList = async (params = {}) => {
  const { data } = await apiClient.get("/accessories-stocks", { params })
  return data
}

// ✅ Get accessories current stock report
export const getAccessoriesStockCurrentReport = async () => {
  const { data } = await apiClient.get(
    `/accessories-stocks/current-stock-report`
  )
  return data
}

// ✅ Get single accessories stock by ID
export const getAccessoriesStockById = async id => {
  const { data } = await apiClient.get(`/accessories-stocks/${id}`)
  return data
}

// ✅ Get single accessories stock pdf by ID
export const getAccessoriesStockPdfById = (id, setLoading) => {
  return downloadAndOpenFile({
    url: `/accessories-stocks/pdf/${id}`,
    mimeType: "application/pdf",
    openInNewTab: true,
    onStart: () => setLoading?.(true),
    onEnd: () => setLoading?.(false),
  })
}

// ✅ Create accessories stock
export const createAccessoriesStock = async payload => {
  const { data } = await apiClient.post("/accessories-stocks", payload)
  return data
}

// ✅ Update accessories stock
export const updateAccessoriesStock = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/accessories-stocks/${id}`, payload)
  return data
}

// ✅ Soft delete (move to trash)
export const deleteAccessoriesStock = async id => {
  const { data } = await apiClient.delete(`/accessories-stocks/${id}`)
  return data
}

// ✅ Get trashed accessories stocks
export const getTrashedAccessoriesStocks = async (params = {}) => {
  const { data } = await apiClient.get("/accessories-stocks/trashed", {
    params,
  })
  return data
}

// ✅ Restore trashed accessories stock
export const restoreAccessoriesStock = async id => {
  const { data } = await apiClient.post(`/accessories-stocks/${id}/restore`)
  return data
}

// ✅ Permanently delete accessories stock
export const forceDeleteAccessoriesStock = async id => {
  const { data } = await apiClient.delete(
    `/accessories-stocks/${id}/force-delete`
  )
  return data
}
